// extracted by mini-css-extract-plugin
export default {"banner":"banners_banner__VHHbG","bannerVideo":"banners_bannerVideo__Tgd8+"};